module.exports = __webpack_public_path__ + "static/media/potrait.5928139f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/potrait.webp
// module id = 456
// module chunks = 0